<template>
  <div class="home">
    <el-container class="home-center">
      <el-header height="120px">
        <Header
            :competitionInfo="competitionInfo || {}"
            :teamName="teamInfo.teamName || ''"
            :username="username"
            :showLogout="true"
            @logout="logout"></Header>
      </el-header>
      <el-container>
        <el-aside width="220px">
          <div class="register-info">{{ $t('home.baseRegistration') }}</div>
          <div @click="toMain('TeamInfo')" class="menu-info" :class="menuValue === 'TeamInfo' ? 'menu-info-check' : ''">
            <el-button type="text"><i class="el-icon-office-building menu-icon"></i>{{ $t('home.teamInfo') }}</el-button>
          </div>
          <div @click="toMain('AthleteInfo')" class="menu-info" :class="menuValue === 'AthleteInfo' ? 'menu-info-check' : ''">
            <el-button type="text"><i class="el-icon-user menu-icon"></i>{{ $t('home.athleteRegistration') }}</el-button>
          </div>
          <div @click="toMain('PersonInfo')" class="menu-info" :class="menuValue === 'PersonInfo' ? 'menu-info-check' : ''">
            <el-button type="text"><i class="el-icon-s-custom menu-icon"></i>{{ $t('home.teamOfficialMgmt') }}</el-button>
          </div>
          <div @click="toMain('PersonProject')" class="menu-info" :class="menuValue === 'PersonProject' ? 'menu-info-check' : ''" v-if="showProjectTypeField('projectTypeJson', '1')">
            <el-button type="text"><i class="el-icon-medal menu-icon"></i>{{ $t('home.individualProject') }}</el-button>
          </div>
          <div @click="toMain('TeamProject')" class="menu-info" :class="menuValue === 'TeamProject' ? 'menu-info-check' : ''" v-if="showProjectTypeField('projectTypeJson', '2')">
            <el-button type="text"><i class="el-icon-trophy menu-icon"></i>{{ $t('home.groupProject') }}</el-button>
          </div>
          <div @click="toMain('TrainProject')" class="menu-info" :class="menuValue === 'TrainProject' ? 'menu-info-check' : ''" v-if="showProjectTypeField('projectTypeJson', '3')">
            <el-button type="text"><i class="el-icon-connection menu-icon"></i>{{ $t('home.pairTrainingProject') }}</el-button>
          </div>
          <div @click="toMain('ProjectSum')" class="menu-info" :class="menuValue === 'ProjectSum' ? 'menu-info-check' : ''">
            <el-button type="text"><i class="el-icon-printer menu-icon"></i>{{ $t('home.summaryAndPrint') }}</el-button>
          </div>
        </el-aside>
        <el-main>
          <transition name="fade" mode="out-in">
            <TeamInfo v-if="menuValue === 'TeamInfo'" key="TeamInfo" @toMain="toMain" :teamInfo="teamInfo" :competitionFormConfigInfo="competitionFormConfigInfo"/>
            <AthleteInfo v-if="menuValue === 'AthleteInfo'" key="AthleteInfo" @toMain="toMain" :teamInfo="teamInfo" :competitionFormConfigInfo="competitionFormConfigInfo"/>
            <PersonInfo v-if="menuValue === 'PersonInfo'" key="PersonInfo" @toMain="toMain" :teamInfo="teamInfo" :competitionFormConfigInfo="competitionFormConfigInfo"/>
            <PersonProject v-if="menuValue === 'PersonProject'" key="PersonProject" @toMain="toMain" :teamInfo="teamInfo" :competitionFormConfigInfo="competitionFormConfigInfo"/>
            <TeamProject v-if="menuValue === 'TeamProject'" key="TeamProject" @toMain="toMain" :teamInfo="teamInfo" :competitionFormConfigInfo="competitionFormConfigInfo"/>
            <TrainProject v-if="menuValue === 'TrainProject'" key="TrainProject" @toMain="toMain" :teamInfo="teamInfo" :competitionFormConfigInfo="competitionFormConfigInfo"/>
            <ProjectSum v-if="menuValue === 'ProjectSum'" key="ProjectSum" @toMain="toMain" @updateTeamStatus="handleUpdateTeamStatus" :teamInfo="teamInfo" :competitionFormConfigInfo="competitionFormConfigInfo"/>
          </transition>
        </el-main>
      </el-container>
      <Footer/>
    </el-container>
  </div>
</template>

<script>
import TeamInfo from "./teamInfo/index.vue";
import AthleteInfo from "./athleteInfo/index.vue";
import PersonInfo from "./personInfo/index.vue";
import PersonProject from "./personProject/index.vue";
import TrainProject from "./trainProject/index.vue";
import TeamProject from "./teamProject/index.vue";
import ProjectSum from "./projectSum/index.vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import {getCompetitionInfo} from "@/api/competition";
import {getCompetitionFormConfigInfo} from "@/api/competitionFormConfig";
import {getTeamInfo} from "@/api/team";
import { logout as logoutApi, appCurrentUser } from "@/api/user";
export default {
  name: "home",
  components: {Header, Footer, TeamInfo, AthleteInfo, PersonInfo, PersonProject, TrainProject, TeamProject, ProjectSum},
  computed: {
    // 显示项目类型
    showProjectTypeField() {
      return (fieldName, fieldType) => {
        const competitionForm = this.competitionFormConfigInfo.competitionForm;
        if (!competitionForm) return false;
        const fieldConfig = competitionForm[fieldName];
        return fieldConfig && fieldConfig.checkedOptions && fieldConfig.checkedOptions.includes(fieldType);
      };
    },
  },
  data() {
    return {
      isRegisterAdmin: '',
      // 当前用户
      username: '',
      // 当前页面
      menuValue: '',
      // 赛事ID
      competitionId: '',
      // 队伍信息
      teamInfo: {
        id: '',
        teamName: '',
        realName: '',
        mobile: '',
        email: '',
        memberUnitId: '',
        regionId: '',
      },
      // 赛事信息
      competitionInfo: {},
      // 赛事表单配置信息
      competitionFormConfigInfo: {},
    };
  },
  created() {
    let id = this.$route.query.id;
    if (!id) {
      this.$router.push({ path: "/index" });
    } else {
      this.competitionId = id;
    }
  },
  mounted() {
    let isRegisterAdmin = Number(localStorage.getItem("isRegisterAdmin"));
    if (isRegisterAdmin === 1) {
      this.$router.push({ path: "/index" });
    } else {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/login?id=" + this.competitionId });
      } else {
        this.findCurrentUser();
        this.findCompetitionInfo();
        this.findTeamInfo();
        this.findCompetitionFormConfigInfo();
      }
    }
  },
  destroyed() {

  },
  methods: {
    // 获取当前登录用户
    findCurrentUser() {
      const cached = localStorage.getItem('username');
      if (cached) this.username = cached;
      appCurrentUser().then((res) => {
        if (res.code === 200) {
          this.username = res.data.account;
          localStorage.setItem('username', res.data.account);
        }
      });
    },
    // 更新队伍状态（提交后全局禁用操作）
    handleUpdateTeamStatus(status) {
      this.teamInfo.status = status;
    },
    // 点击菜单
    toMain(value) {
      if (value !== 'TeamInfo' && !this.teamInfo.id) {
        this.$message.warning(this.$t('home.needCompleteTeamInfoFirst'));
        return;
      }
      this.menuValue = value;
    },
    // 获取队伍信息
    findTeamInfo() {
      getTeamInfo(this.competitionId).then((res) => {
        if(res.data != null){
          this.teamInfo = res.data;
        }
      });
    },
    // 获取赛事信息
    findCompetitionInfo(){
      getCompetitionInfo(this.competitionId).then((res) => {
        this.competitionInfo = res.data;
      });
    },
    // 获取赛事表单配置信息
    findCompetitionFormConfigInfo() {
      getCompetitionFormConfigInfo(this.competitionId).then((res) => {
        let data = res.data;
        if (!data.id) {
          return this.$message.error(this.$t('home.configNotComplete'));
        } else {
          this.competitionFormConfigInfo = res.data;
          this.menuValue = 'TeamInfo';
        }
      })
    },
    // 退出登录
    logout() {
      this.$confirm(this.$t('home.confirmLogout'), this.$t('common.prompt'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: "warning",
      }).then(() => {
        logoutApi().finally(() => {
          localStorage.removeItem("token");
          this.$router.push({path: "/login?id=" + this.competitionId});
        });
      }).catch(() => {
      });
    },
  },
};
</script>
<style lang="scss" scoped>

.home {
  width: 100%;
  background-color: #f8f9fc;

  .home-center {
    height: 100vh;

    // 左侧栏标题
    .register-info {
      font-size: 19px;
      font-weight: 600;
      background: linear-gradient(135deg, #001c58 0%, #123a80 100%);
      color: #FFFFFF;
      margin-top: 2px;
      padding-left: 24px;
      height: 56px;
      line-height: 56px;
      letter-spacing: 4px;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 56px;
        height: 3px;
        border-radius: 2px;
        background: linear-gradient(90deg, #409EFF, rgba(64, 158, 255, 0));
      }
    }

    // 左侧菜单项
    .menu-info {
      text-align: left;
      padding-left: 42px;
      height: 52px;
      line-height: 52px;
      cursor: pointer;
      transition: all 0.3s ease;
      position: relative;
      border-left: 3px solid transparent;

      &:hover {
        background-color: #f0f5ff;
        border-left-color: #409EFF;
        padding-left: 46px;

        .el-button {
          color: #1E50AE;
        }
      }

      .el-button {
        color: #4d4d4d;
        font-size: 14px;
        padding: 0;
        width: 100%;
        text-align: left;
        border: none;
        transition: color 0.3s ease;

        .menu-icon {
          font-size: 16px;
          margin-right: 10px;
        }
      }
    }

    // 左侧菜单选中态
    .menu-info-check {
      &, &:hover {
        background: linear-gradient(90deg, #e8f0fd 0%, #f6faff 100%);
        border-left-color: #1E50AE;
      }

      &::after {
        content: '';
        position: absolute;
        right: 18px;
        top: 50%;
        width: 7px;
        height: 7px;
        border-top: 2px solid #1E50AE;
        border-right: 2px solid #1E50AE;
        transform: translateY(-50%) rotate(45deg);
      }

      .el-button {
        color: #1E50AE;
        font-weight: 600;
      }
    }

    .el-header {
      color: #333;
      padding: 0;
      position: relative;
      z-index: 3;
      box-shadow: 0 3px 10px rgba(0, 28, 88, 0.1);
    }

    .el-aside {
      color: #333;
      text-align: left;
      background-color: #FFFFFF;
      box-shadow: 4px 0 16px rgba(0, 28, 88, 0.05);
      position: relative;
      // 与主内容区同高，底部对齐固定 Footer 上缘，避免伸入 Footer 区域
      height: calc(100vh - 180px);
    }

    .el-main {
      height: calc(100vh - 180px);
      background-color: #f8f9fc;
      padding: 24px 32px;

      &::-webkit-scrollbar {
        width: 6px;
      }

      &::-webkit-scrollbar-thumb {
        background: #c4cddb;
        border-radius: 3px;
      }

      &::-webkit-scrollbar-track {
        background: transparent;
      }
    }

    // 主内容切换过渡
    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.2s ease;
    }

    .fade-enter,
    .fade-leave-to {
      opacity: 0;
    }
  }
}
</style>
